import React from 'react';
import {
  Box,
  Typography,
  Stack,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  IconButton,
  Divider,
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight,
  CalendarMonth,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from '@mui/icons-material';
import { VUE_OPTIONS } from '../constants';

const PlanningHeader = ({
  currentMonth,
  vue,
  onVueChange,
  onScroll,
  onToday,
}) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{ mb: 4 }}
  >
    <Box>
      <Typography
        variant="h4"
        sx={{ fontWeight: 800, color: '#1B254B', letterSpacing: '-0.5px' }}
      >
        Gestion des Réservations
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
        <CalendarMonth sx={{ color: '#4318FF', fontSize: 20 }} />
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, color: '#4318FF' }}
        >
          {currentMonth}
        </Typography>
        <Typography
          sx={{ color: '#A3AED0', fontWeight: 600, fontSize: '0.85rem' }}
        >
          • Vue {vue} jours
        </Typography>
      </Stack>
    </Box>

    <Stack
      direction="row"
      alignItems="center"
      bgcolor="white"
      borderRadius="16px"
      p={0.75}
      boxShadow="0px 10px 30px rgba(112, 144, 176, 0.12)"
      sx={{ border: '1px solid #E0E5F2', gap: 0.5 }}
    >
      <IconButton onClick={() => onScroll('left')} size="small">
        <KeyboardDoubleArrowLeft />
      </IconButton>
      <IconButton onClick={() => onScroll('left', 1)} size="small">
        <ChevronLeft />
      </IconButton>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5, my: 1 }} />

      <ToggleButtonGroup
        value={vue}
        exclusive
        onChange={(e, v) => v && onVueChange(v)}
        size="small"
        sx={{ border: 'none' }}
      >
        {VUE_OPTIONS.map((v) => (
          <ToggleButton
            key={v}
            value={v}
            sx={{
              border: 'none',
              fontWeight: 700,
              borderRadius: '10px !important',
              px: 2,
              textTransform: 'none',
            }}
          >
            {v === 1 ? '1j' : `${v}j`}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5, my: 1 }} />

      <IconButton onClick={() => onScroll('right', 1)} size="small">
        <ChevronRight />
      </IconButton>
      <IconButton onClick={() => onScroll('right')} size="small">
        <KeyboardDoubleArrowRight />
      </IconButton>

      <Button
        variant="contained"
        disableElevation
        onClick={onToday}
        sx={{
          ml: 1,
          bgcolor: '#4318FF',
          borderRadius: '12px',
          fontWeight: 800,
          textTransform: 'none',
        }}
      >
        Aujourd'hui
      </Button>
    </Stack>
  </Stack>
);

export default PlanningHeader;
